import type * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const POPOVER_SIDES = [ "top", "bottom", "left", "right" ] as const;

export const POPOVER_ALIGNMENTS = [ "start", "center", "end" ] as const;

export const POPOVER_CONTENT_CLASS = [
  "z-50 w-80 rounded-sys-sm border border-solid border-muted",
  "bg-surface-default p-4 text-foreground shadow-md outline-none",
].join(" ");

export const POPOVER_SIDE_OFFSET = 4;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TPopoverSide = (typeof POPOVER_SIDES)[number];

export type TPopoverAlign = (typeof POPOVER_ALIGNMENTS)[number];

export type TPopoverProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Root>;

export type TPopoverTriggerElement = ComponentRef<typeof PopoverPrimitive.Trigger>;
export type TPopoverTriggerProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger>;

export type TPopoverAnchorElement = ComponentRef<typeof PopoverPrimitive.Anchor>;
export type TPopoverAnchorProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Anchor>;

export type TPopoverContentElement = ComponentRef<typeof PopoverPrimitive.Content>;
export type TPopoverContentProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>;
